<template>
  <div class="dropdown" ref="dropdown" :class="{'in-input-set': inInputSet}">
    <label class="dropdown-label" v-if="label">{{label}}</label>
    <div
      class="toggler noselect "
      ref="toggler"
      :class="{'disabled ': disabled,'togglerDropdown': isNavbarDropdown, 'active': active, 'error': error}"
      @click.prevent="toggle"
      :title="dropdownTitle"
      :tabindex="tabIndex"
      :name="name"
      @blur="onBlurToggler"
      @focus="onFocusToggler"
      v-on:keydown.arrow-down.prevent="navigateList('down')"
      v-on:keydown.arrow-up.prevent="navigateList('up')"
      v-on:keydown.tab="onTabToggler"
      v-on:keyup.enter="onEnter"
    >
      <div v-html="formatText(mocked_selected)" :class="{'spanDropdown': isNavbarDropdown, 'placeholderActive': placeholderActive, 'option-selected': true}"></div>
      <div v-if="!disabled">
        <i class="fas fa-angle-down" v-if="!toggled"></i>
        <i class="fas fa-angle-up" v-if="toggled"></i>
      </div>
    </div>
    <div :class="['menu', { toggled: toggled }]">
      <div v-if="searchable" class="search-wrapper">
        <input
          v-model="search"
          class="filter"
          :placeholder="filterPlaceholder"
          :title="filterTitle"
        />
        <i class="fa fa-search search-icon"></i>
      </div>
      <div
        class="items"
        v-for="(entry, i) in displayed"
        :class="{'hovered': focusedItem === entry}"
        :key="i"
        :id="'item-' + i"
        @click.prevent="itemClick(entry)"
        @mouseover="itemMouseOver(entry)"
        v-html="formatText(entry)"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'dropdown',
    props: {
        selected: {
            default: '',
        },
        entries: {
            type: Array,
            default: () => [''],
        },
        isNavbarDropdown: {
            type: Boolean,
            default: false,
        },
        formatText: {
            type: Function,
            default: (x) => x,
        },
        formatValue: {
            type: Function,
            default: undefined,
        },
        dropdownTitle: {
            type: String,
            default: '',
            required: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        searchable: {
            type: Boolean,
            default: false,
        },
        filterPlaceholder: {
            type: String,
            default: '',
            required: false,
        },
        filterTitle: {
            type: String,
            default: '',
            required: false,
        },
        label: {
            type: String,
            default: '',
            required: false,
        },
        // eslint-disable-next-line vue/require-prop-type-constructor
        customClickEvent: false,
        inInputSet: {
            type: Boolean,
            default: false,
        },
        active: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
            required: false,
        },
        tabIndex: Number,
        name: {
            type: String,
            required: false,
        },
    },
    data: () => ({
        toggled: false,
        search: '',
        focusedIndex: -1,
    }),
    computed: {
        mocked_selected: {
            get() {
                if (!this.selected) {
                    return this.placeholder;
                }
                return this.selected;
            },
            set(newValue) {
                this.$emit(
                    'update:selected',
                    // eslint-disable-next-line no-nested-ternary
                    this.formatValue ? this.entries.find((x) => this.formatValue(x) === this.formatValue(newValue)) : this.entries.indexOf(newValue) >= 0 ? newValue : '',
                );
            },
        },
        placeholderActive() {
            if (!this.selected && this.placeholder) {
                return true;
            }
            return false;
        },
        displayed() {
            if (!this.search) {
                return this.entries;
            }
            return this.formatValue
                ? this.entries.filter((el) => this.formatValue(el).includes(this.search))
                : this.entries.filter((el) => el.includes(this.search));
        },
        focusedItem() {
            return this.displayed[this.focusedIndex];
        },
        hadChosenEntry() {
            return this.placeholder && this.placeholder !== this.mocked_selected;
        },
    },
    methods: {
        toggle() {
            if (this.disabled) {
                return;
            }
            this.toggled = !this.toggled;
            if (this.toggled) {
                if (this.hadChosenEntry) {
                    this.scrollList('up');
                    this.scrollList('down');
                } else {
                    this.focusedIndex = -1;
                    this.scrollList('up');
                }
            }
            this.$nextTick(() => {
                this.$emit('onToggle', this.toggled);
            });
        },
        outsideClick(e) {
            if (!this.$refs.dropdown.contains(e.target)) {
                this.toggled = false;
                if (this.hadChosenEntry) {
                    this.focusedIndex = this.displayed.indexOf(this.mocked_selected);
                }
            }
        },
        itemClick(entry) {
            if (!this.customClickEvent) {
                this.mocked_selected = entry;
                this.focusedIndex = this.displayed.indexOf(entry);
                this.toggle();
            } else {
                this.toggle();
                this.$emit('itemClick', entry);
            }
        },
        itemMouseOver(entry) {
            this.focusedIndex = this.displayed.indexOf(entry);
        },
        onBlurToggler() {
            this.$emit('dropdownOnBlur');
        },
        onFocusToggler() {
            this.$emit('dropdownOnFocus');
        },
        onTabToggler() {
            this.toggled = false;
            if (this.hadChosenEntry) {
                this.focusedIndex = this.displayed.indexOf(this.mocked_selected);
            }
        },
        navigateList(direction) {
            if (direction === 'down') {
                if (!this.toggled) {
                    this.toggle();
                    if (this.hadChosenEntry) {
                        this.focusedIndex = this.displayed.indexOf(this.mocked_selected);
                        this.scrollList('up');
                        this.scrollList('down');
                        return;
                    }
                    this.focusedIndex = -1;
                }
                if (this.focusedIndex < (this.displayed.length - 1)) {
                    this.focusedIndex++;
                    this.scrollList('down');
                }
            } else {
                if (this.focusedIndex === 0) {
                    this.toggle();
                }
                if (this.focusedIndex > -1) {
                    this.focusedIndex--;
                    this.scrollList('up');
                }
            }
        },
        scrollList(direction) {
            if (direction === 'down') {
                this.$nextTick(() => {
                    const item = document.getElementById(`item-${this.focusedIndex}`);
                    if (item && item.offsetParent) {
                        const menuContainerHeight = item.offsetParent.offsetHeight;
                        const menuContainerTop = item.offsetParent.getBoundingClientRect().top;
                        const itemBottom = item.getBoundingClientRect().bottom;
                        if (itemBottom > menuContainerTop + menuContainerHeight) {
                            item.scrollIntoView(false);
                        }
                    }
                });
            } else {
                this.$nextTick(() => {
                    let item = document.getElementById('item-0');
                    if (this.focusedIndex > -1) {
                        item = document.getElementById(`item-${this.focusedIndex}`);
                    }
                    if (item && item.offsetParent) {
                        const menuContainerHeight = item.offsetParent.offsetHeight;
                        const menuContainerBottom = item.offsetParent.getBoundingClientRect().bottom;
                        const itemTop = item.getBoundingClientRect().top;
                        if (itemTop < menuContainerBottom - menuContainerHeight) {
                            item.scrollIntoView(false);
                        }
                    }
                });
            }
        },
        onEnter() {
            if (this.toggled) {
                this.itemClick(this.focusedItem);
            } else {
                this.toggle();
            }
        },
    },
    mounted() {
        window.addEventListener('click', this.outsideClick);
    },
    destroyed() {
        window.removeEventListener('click', this.outsideClick);
    },
};
</script>

<style lang="scss" scoped>

$border-color: #8492a6;
.dropdown {
  position: relative;
  max-width: 300px;
  &.in-input-set {
    max-width: 100%;
    font-size: $font-size-body-default;
    .toggler {
      box-shadow: none;
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 2px;
      color: $color-neutral-dark-400;
      &:focus {
        outline: 0;
        border: 1px solid $color-semantic-blue-300;
      }
      &.active {
        border: 1px solid $color-semantic-blue-300;
        outline: 0 !important;
      }
      &.error {
        border: 1px solid $color-semantic-red-300;
      }
      .fas {
        color: $color-neutral-dark-200;
      }
    }
    div.menu {
      border-radius: 2px;
      border: 1px solid $color-neutral-light-500;
      box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
      color: $color-neutral-dark-300;
      .items {
        font-size: $font-size-body-default;
      }
    }
  }
  .toggler {
    box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 3px,
      rgba(0, 0, 0, 0.1) 0px 0px 0px 1px;
    background: white;
    padding: 5px 10px;
    position: relative;
    border-radius: 5px;
    cursor: pointer;
    .option-selected {
        min-height: 1.188rem;
    }
    &.disabled {
      cursor: default;
    }
    i {
      position: absolute;
      right: 0.75rem;
      top: 50%;
      transform: translate(0px, -50%);
    }
    .spanDropdown{
      font-size:12px;
    }
    .placeholderActive{
      color: #888888;
    }
  }
  div.menu {
    z-index: 10;
    margin-top: 0.25rem;
    box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 3px,
      rgba(0, 0, 0, 0.1) 0px 0px 0px 1px;
    border-radius: 5px;
    position: absolute;
    width: 100%;
    background: white;
    display: none;
    max-height: 200px;
    overflow-y: scroll;
    &.toggled {
      display: block;
    }
    .items {
      line-height: 1.75rem;
      cursor: pointer;
      padding: 0.5rem 0.75rem;
      font-size:13px;
      &:hover {
        background: $gray-300;
      }
      &.hovered {
        background: $gray-300;
      }
    }
    .search-wrapper {
      position: relative;
    }
    .filter {
      line-height: 1.75rem;
      padding: 0.5rem 0.75rem;
      border: none;
      border-bottom: 1px solid #8492a6;
      width: 100%;
    }
    .search-icon {
      position: absolute;
      right: 0.5rem;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.dropdown-label {
  color: $gray-900;
  font-size: 1rem;
  margin-left: 0.5rem;
  margin-bottom: 0.25rem;
}

</style>>
